// Generated by purs version 0.15.4
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as PartyCarlo_Components_HTML_Utils from "../PartyCarlo.Components.HTML.Utils/index.js";
var loadingAnimation = /* #__PURE__ */ Halogen_HTML_Elements.div([ /* #__PURE__ */ PartyCarlo_Components_HTML_Utils.css("loading-circle") ])([ /* #__PURE__ */ Halogen_HTML_Elements.div([ /* #__PURE__ */ PartyCarlo_Components_HTML_Utils.css("spinner") ])([  ]) ]);
export {
    loadingAnimation
};
